import type { MPLPreApprovalOffer } from 'commonTypes/api/scenarios/CreditSelectionScreenContent';
import { OFFER_STATUS } from 'constants/offer';

import { loansStatusToOfferStatusAdapter } from 'shared/lib';
import type { TOffer } from 'shared/types/TRankingService';

export const getOfferStatus = (mplOffer: MPLPreApprovalOffer): TOffer['status'] => {
  if (mplOffer.isAlreadySentFromSameBank) {
    return OFFER_STATUS.ALREADY_SENT_FROM_SAME_BANK;
  }
  if (!mplOffer.apiStatus) {
    return OFFER_STATUS.NEW;
  }

  return loansStatusToOfferStatusAdapter(mplOffer.apiStatus);
};
